import { z } from "zod";
import { customErrorMap, myPreProcess } from "../shared/validation/zod";

z.setErrorMap(customErrorMap);

export const DocumentCarCustomDataSchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    document_car_id: z.number(),
    field_index: z.number(),
    field_id: z.number().nullable(),

    created_at: z.string(),
    updated_at: z.string(),


    // nullable
    field_value: z.string().nullable(),

});

export const DocumentCarCustomDataFormSchema = z.object({

    // optional in create
    id: z.number().optional(),
    business_id: z.number().optional(),
    document_car_id: z.number().optional(),
    field_id: z.number().nullish(),

    created_at: z.string().optional(),
    updated_at: z.string().optional(),


    // required
    field_index: z.number(),

    // optional nullable fields
    field_value: z.preprocess((val) => myPreProcess(val), z.string().nullish()),

});

export type DocumentCarCustomData = z.infer<typeof DocumentCarCustomDataSchema>
export type DocumentCarCustomDataForm = z.infer<typeof DocumentCarCustomDataFormSchema>